import React from 'react';
import { useTranslations } from 'js/hooks/i18n';
import { Icon } from 'js/components/common/Icon';
import { getClassNames } from 'js/utils/classNames.util';

import Bullets from './Bullets';
import * as hooks from './hooks';

import style from './index.scss';

export const Controls = (props) => {
    const {
        sliderMove,
        sliderMoveLeft,
        sliderMoveRight
    } = hooks.useSliderNavigation(props);
    const {
        options: {
            arrows,
            bullets,
            buttons
        },
        classNames: {
            leftArrow = '',
            rightArrow = '',
            ...classNames
        } = {},
        activeSlide,
        slidesCount,
        infinite,
        isBulletsClickable,
        showDisabledArrows = false
    } = props;
    const arrowsStyle = hooks.useArrowStyles(arrows);
    const bulletsClassNames = hooks.useBulletsClassNames(classNames);
    const onBulletClick = hooks.useBulletClickHandler({ activeSlide, sliderMove });
    const translate = useTranslations('playtech.mobile.system.slider.');
    const isLeftArrowActive = !(!infinite && activeSlide === 0);
    const isRightArrowActive = !(!infinite && activeSlide === slidesCount - 1);
    const leftArrowClassNames = getClassNames([
        style.leftArrow,
        classNames.arrows || '',
        leftArrow,
        showDisabledArrows && !isLeftArrowActive ? style.disabledArrow : ''
    ]);
    const rightArrowClassNames = getClassNames([
        style.rightArrow,
        classNames.arrows || '',
        rightArrow,
        showDisabledArrows && !isRightArrowActive ? style.disabledArrow : ''
    ]);

    return (
        <>
            {arrows.enabled && (showDisabledArrows || isLeftArrowActive) && (
                <Icon
                    style={arrowsStyle}
                    className={leftArrowClassNames}
                    type={`${leftArrow ? '' : 'leftArrow'}`}
                    {...isLeftArrowActive && { onClick: sliderMoveLeft }}
                    aria-label={translate('aria-label.leftArrowButton')}
                />
            )}
            {arrows.enabled && (showDisabledArrows || isRightArrowActive) && (
                <Icon
                    style={arrowsStyle}
                    className={rightArrowClassNames}
                    type={`${rightArrow ? '' : 'rightArrow'}`}
                    {...isRightArrowActive && { onClick: sliderMoveRight }}
                    aria-label={translate('aria-label.rightArrowButton')}
                />
            )}
            {(bullets.enabled || buttons.enabled) && (
                <Bullets
                    count={slidesCount}
                    onClick={onBulletClick}
                    activeSlide={activeSlide}
                    position={bullets.position}
                    showNumbers={buttons.enabled}
                    classNames={bulletsClassNames}
                    isBulletsClickable={isBulletsClickable}
                />
            )}
        </>
    );
};

export default Controls;
